export default __webpack_public_path__ + "static/media/acne-ON.e8fdceaa.png";